/* one% default product page: option buttons -> variant, price/URL sync, gallery, AJAX add to cart. */
(function () {
  if (customElements.get('op-product-form')) return;

  class OpProductForm extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.op-product') || this;
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.select = this.querySelector('[data-op-variant-select]');
      this.options = this.querySelector('[data-op-options]');
      this.addBtn = this.querySelector('[data-op-add]');
      this.buyBtn = this.querySelector('[data-op-buy-now]'); // marketplace mode: opens the buy dialog
      this.status = this.querySelector('[data-op-status]');
      this.strip = this.querySelector('[data-op-strip]');
      try {
        this.variants = JSON.parse(this.querySelector('[data-op-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }

      if (this.options && (this.select || this.buyBtn)) {
        this.options.hidden = false;
        this.section.classList.add('is-enhanced');
        this.options.addEventListener('change', () => this.onOptionChange());
      }

      this.querySelectorAll('[data-op-qty]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = this.querySelector('input[name="quantity"]');
          if (!input) return;
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.opQty));
          input.value = String(next);
        });
      });

      this.querySelectorAll('[data-op-thumb]').forEach((btn) => {
        btn.addEventListener('click', () => this.showMedia(btn.dataset.opThumb));
      });
      if (this.strip) {
        this.strip.addEventListener('scroll', () => {
          clearTimeout(this.scrollT);
          this.scrollT = setTimeout(() => this.markThumb(), 80);
        }, { passive: true });
      }

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      if (this.buyBtn) {
        this.buyBtn.addEventListener('click', () => {
          if (window.OnePercentBuy) window.OnePercentBuy.open(this.buyBtn.dataset.variantId);
        });
      }
    }

    currentVariant() {
      const id = Number(this.select && this.select.value);
      return this.variants.find((v) => v.id === id);
    }

    onOptionChange() {
      const picked = [];
      this.options.querySelectorAll('input[data-op-option]:checked').forEach((input) => {
        picked[Number(input.dataset.opOption)] = input.value;
      });
      const variant = this.variants.find((v) => v.options.every((o, i) => o === picked[i]));
      this.setStatus('');
      if (this.buyBtn) this.buyBtn.disabled = !variant;
      if (!variant) {
        this.setButton(false, this.addBtn && this.addBtn.dataset.unavailableLabel);
        return;
      }
      if (this.select) this.select.value = String(variant.id);
      if (this.buyBtn) this.setBuy(variant.id);
      this.renderVariant(variant);
    }

    renderVariant(v) {
      const now = this.querySelector('[data-op-price-now]');
      const was = this.querySelector('[data-op-price-was]');
      if (now) now.textContent = v.price;
      if (was) {
        was.textContent = v.compare || '';
        was.hidden = !v.compare;
      }
      if (this.addBtn) this.setButton(v.available, v.available ? this.addBtn.dataset.addLabel : this.addBtn.dataset.soldOutLabel);
      if (v.media) this.showMedia(String(v.media));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Marketplace mode: an option with no listing on any store reads "Coming soon" and can't be bought.
    setBuy(id) {
      const B = window.ONEPERCENT_BUY;
      const v = B && B.variants[String(id)];
      const soon = !!(v && v.soon);
      this.buyBtn.dataset.variantId = String(id);
      this.buyBtn.disabled = soon;
      this.buyBtn.textContent = soon ? B.soonLabel || 'Coming soon' : this.buyBtn.dataset.buyLabel;
    }

    setButton(enabled, label) {
      if (!this.addBtn) return;
      this.addBtn.disabled = !enabled;
      if (label) this.addBtn.textContent = label;
    }

    showMedia(id) {
      if (!this.strip) return;
      const slide = this.strip.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.strip.scrollTo({ left: slide.offsetLeft - this.strip.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.markThumb(id);
    }

    markThumb(id) {
      if (!this.strip) return;
      if (!id) {
        const i = Math.round(this.strip.scrollLeft / Math.max(1, this.strip.clientWidth));
        const slide = this.strip.children[i];
        id = slide && slide.dataset.mediaId;
      }
      this.querySelectorAll('[data-op-thumb]').forEach((t) => t.classList.toggle('is-active', t.dataset.opThumb === id));
    }

    setStatus(html, isError) {
      if (!this.status) return;
      this.status.classList.toggle('is-error', !!isError);
      this.status.innerHTML = html;
    }

    async onSubmit(e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (!this.addBtn || this.addBtn.disabled) return;
      const label = this.addBtn.textContent;
      this.addBtn.disabled = true;
      this.addBtn.setAttribute('aria-busy', 'true');
      this.setStatus('');
      try {
        const res = await fetch(this.form.getAttribute('action') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form)
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || '');
        const cartRes = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartRes.json();
        window.dispatchEvent(new CustomEvent('onepercent:cart', { detail: { count: cart.item_count, item: data.variant_id || null } }));
        const s = this.status ? this.status.dataset : {};
        const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        this.setStatus(esc(s.addedText) + ' <a href="' + esc(this.dataset.cartUrl || '/cart') + '">' + esc(s.viewCartLabel) + '</a>');
      } catch (err) {
        if (this.status) {
          this.status.classList.add('is-error');
          this.status.textContent = (err && err.message) || this.status.dataset.errorText || '';
        }
      } finally {
        this.addBtn.removeAttribute('aria-busy');
        const v = this.currentVariant();
        this.addBtn.disabled = v ? !v.available : false;
        this.addBtn.textContent = label;
      }
    }
  }

  customElements.define('op-product-form', OpProductForm);
})();
